<template>
  <div>
    <div class="row">
      <div class="col-xs-4">
        <div :class="[{'has-error': hasFieldErrors(pInputNamePrefix + '.dateRule.startDateText')}]">
          <label :for="pInputIdPrefix + '_dateRule_startDateText'" class="control-label sr-only">
            {{ 'dictionary.general.from' | i18nText(pDictionary) }}
          </label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fa-light fa-calendar"></i>  {{ 'dictionary.general.from' | i18nText(pDictionary) }}</span>
            <input type="text" ref="startDateText"
                   :id="pInputIdPrefix + '_dateRule_startDateText'"
                   :name="pInputNamePrefix + '.dateRule.startDateText'"
                   :placeholder="pDictionary['dictionary.format.date.hint']"
                   v-model="dateRule.startDateText"
                   @change="onDateChange"
                   size="10" maxlength="10"
                   class="form-control datepicker startDateText"
                   autocomplete="off">
          </div>
          <span v-for="(error, index) in getFieldErrors(pInputNamePrefix + '.dateRule.startDateText')"
                :key="'errorList_' + pInputIdPrefix + '_startDateText_error_' + index" class="help-block">{{ error }}</span>
        </div>
      </div>
      <div class="col-xs-4">
        <div :class="{'has-error': hasFieldErrors(pInputNamePrefix + '.dateRule.endDateText')}">
          <label :for="pInputIdPrefix + '_dateRule_endDateText'" class="control-label sr-only">
            {{ 'dictionary.general.to' | i18nText(pDictionary) }}
          </label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fa-light fa-calendar"></i>  {{ 'dictionary.general.to' | i18nText(pDictionary) }}</span>
            <input type="text" ref="endDateText"
                   :id="pInputIdPrefix + '_dateRule_endDateText'"
                   :name="pInputNamePrefix + '.dateRule.endDateText'"
                   :placeholder="pDictionary['dictionary.format.date.hint']"
                   v-model="dateRule.endDateText"
                   @change="onDateChange"
                   size="10" maxlength="10"
                   class="form-control datepicker endDateText"
                   autocomplete="off">
          </div>
          <span v-for="(error, index) in getFieldErrors(pInputNamePrefix + '.dateRule.endDateText')"
                :key="'errorList_' + pInputIdPrefix + '_endDateText_error_' + index" class="help-block">{{ error }}</span>
        </div>
      </div>
      <div class="col-xs-4">
        <div class="checkbox">
          <label>
            <input type="checkbox" v-model="dateRule.autofill" value="true"
                   :name="pInputNamePrefix + '.dateRule.autofill'" :disabled="autoFillDisabled">  {{ 'dictionary.date.rule.autofill' | i18nText(pDictionary) }}
            <i aria-hidden="true" data-toggle="tooltip" data-container="body" data-placement="top" title=""
               class="fa-light fa-circle-question" :data-original-title="pDictionary['dictionary.date.rule.autofill.hint']"></i>
          </label>
        </div>
      </div>
    </div>
    <div class="bs3-margin-top">
      <div>

        <!-- Nav tabs -->
        <ul class="nav nav-tabs" role="tablist">
          <li role="presentation" :class="{'active': applicableWeekDaysActive}" @click="applicableDaysTab = 'APPLICABLE_WEEK_DAYS' ">
            <a href="#applicableWeekDays" aria-controls="home" role="tab" data-toggle="tab">{{ 'dictionary.date.rule.applicable.week.days' | i18nText(pDictionary)}}</a></li>
          <li role="presentation" :class="{'active': applicableMonthDaysActive}" @click="applicableDaysTab = 'APPLICABLE_MONTH_DAYS'">
            <a href="#applicableMonthDays" aria-controls="profile" role="tab" data-toggle="tab">{{ 'dictionary.date.rule.applicable.month.days' | i18nText(pDictionary)}}</a></li>
        </ul>

        <!-- Tab panes -->
        <div class="tab-content">
          <div role="tabpanel" :class="['tab-pane', {'active': applicableWeekDaysActive}]" id="applicableWeekDays">
            <div class="btn-group bs3-toggle-buttons">
              <label v-if="pCalendarFirstDayOfWeek !== 1" :class="['btn btn-default bs3-margin-top', {'active': dateRule.appliesSunday }]">
                <input type="checkbox"  v-model="dateRule.appliesSunday" value="true"
                       :name="pInputNamePrefix + '.dateRule.appliesSunday'" :disabled="!applicableWeekDaysActive"> {{'dictionary.picker.date.days.sunday' | i18nText(pDictionary)}}
              </label>
              <label :class="['btn btn-default bs3-margin-top', {'active': dateRule.appliesMonday }]">
                <input type="checkbox" v-model="dateRule.appliesMonday" value="true"
                       :name="pInputNamePrefix + '.dateRule.appliesMonday'" :disabled="!applicableWeekDaysActive"> {{'dictionary.picker.date.days.monday' | i18nText(pDictionary)}}
              </label>
              <label :class="['btn btn-default bs3-margin-top', {'active': dateRule.appliesTuesday }]">
                <input type="checkbox" v-model="dateRule.appliesTuesday" value="true"
                       :name="pInputNamePrefix + '.dateRule.appliesTuesday'" :disabled="!applicableWeekDaysActive"> {{'dictionary.picker.date.days.tuesday' | i18nText(pDictionary)}}
              </label>
              <label :class="['btn btn-default bs3-margin-top', {'active': dateRule.appliesWednesday }]">
                <input type="checkbox" v-model="dateRule.appliesWednesday" value="true"
                       :name="pInputNamePrefix + '.dateRule.appliesWednesday'" :disabled="!applicableWeekDaysActive"> {{'dictionary.picker.date.days.wednesday' | i18nText(pDictionary)}}
              </label>
              <label :class="['btn btn-default bs3-margin-top', {'active': dateRule.appliesThursday }]">
                <input type="checkbox" v-model="dateRule.appliesThursday" value="true"
                       :name="pInputNamePrefix + '.dateRule.appliesThursday'" :disabled="!applicableWeekDaysActive"> {{'dictionary.picker.date.days.thursday' | i18nText(pDictionary)}}
              </label>
              <label :class="['btn btn-default bs3-margin-top', {'active': dateRule.appliesFriday }]">
                <input type="checkbox" v-model="dateRule.appliesFriday" value="true"
                       :name="pInputNamePrefix + '.dateRule.appliesFriday'" :disabled="!applicableWeekDaysActive"> {{'dictionary.picker.date.days.friday' | i18nText(pDictionary)}}
              </label>
              <label :class="['btn btn-default bs3-margin-top', {'active': dateRule.appliesSaturday }]">
                <input type="checkbox" v-model="dateRule.appliesSaturday" value="true"
                       :name="pInputNamePrefix + '.dateRule.appliesSaturday'" :disabled="!applicableWeekDaysActive"> {{'dictionary.picker.date.days.saturday' | i18nText(pDictionary)}}
              </label>
              <label v-if="pCalendarFirstDayOfWeek === 1" :class="['btn btn-default bs3-margin-top', {'active': dateRule.appliesSunday }]">
                <input type="checkbox"  v-model="dateRule.appliesSunday" value="true"
                       :name="pInputNamePrefix + '.dateRule.appliesSunday'" :disabled="!applicableWeekDaysActive"> {{'dictionary.picker.date.days.sunday' | i18nText(pDictionary)}}
              </label>
            </div>
          </div>
          <div role="tabpanel" :class="['tab-pane', {'active': applicableMonthDaysActive}]" id="applicableMonthDays">
            <div class="btn-group bs3-toggle-buttons">
              <label v-for="index in applicableMonthDays.length - 1" :class="['btn btn-default bs3-margin-top', {'active': applicableMonthDays[index] }]" :key="'applicableDate'+ index">
                <input type="checkbox"  v-model="applicableMonthDays[index]" :value="index"
                       :name="pInputNamePrefix + '.dateRule.applicableDates'" :disabled="!applicableMonthDaysActive"> {{index}}
              </label>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import BaseMixin from "@/mixins/base-mixin";
import FormMixin from "@/mixins/form-mixin";
import FormatMixin from "@/mixins/format-mixin";

export default {
  name: "DateRuleForm",
  mixins: [BaseMixin, FormMixin, FormatMixin],
  model: {
    prop: 'pDateRule',
  },
  props: {
    pDateRule: Object,
    pCalendarFirstDayOfWeek: Number,
    pInputNamePrefix: {
      type: String,
      default: function () {
        return 'dataForm.data'
      }
    },
    pInputIdPrefix: {
      type: String,
      default: function () {
        return 'dataForm_data'
      }
    },
  },
  data: function () {
    return {
      dateRule: this.pDateRule,
      applicableMonthDays: this.pDateRule.applicableMonthDays,
      applicableDaysTab: this.pDateRule.applicableMonthDays.reduce((accumulator, value) => accumulator || value, false) ? "APPLICABLE_MONTH_DAYS" : "APPLICABLE_WEEK_DAYS"
    }
  },
  methods: {
    onDateChange: function() {
      console.log("onDateChange");
      if(!this.dateRule.startDateText || !this.dateRule.endDateText) {
        this.dateRule.autofill = false;
      }
    }
  },
  watch: {
    dateRule: function (newDateRule) {
      this.$emit('input', newDateRule);
    },
    autoFillDisabled: function(newAutoFillDisabled) {
      if(newAutoFillDisabled) {
        this.dateRule.autofill = false;
      }
    }
  },
  computed: {
    autoFillDisabled: function() {
      return !this.dateRule.startDateText
             || !this.dateRule.endDateText
             || this.applicableMonthDays.reduce((accumulator, value) => accumulator || value, false);
    },
    applicableWeekDaysActive: function() {
      return this.applicableDaysTab === "APPLICABLE_WEEK_DAYS";
    },
    applicableMonthDaysActive: function() {
      return this.applicableDaysTab === "APPLICABLE_MONTH_DAYS";
    }
  },
  mounted: function () {
    let _component = this;

    // Init StartDateText.
    let $startDateText = $(this.$refs.startDateText);
    $startDateText.initFromDatePicker(
        {
          dateElId: $startDateText.attr('id'),
          linkDateElId: null,
          minDate: $startDateText.data('min-date-text'),
          maxDate: $startDateText.data('max-date-text'),
          bs3: true,
          f: function (selectedDate) {
            _component.$data.dateRule.startDateText = selectedDate;
            _component.$refs.startDateText.dispatchEvent(new Event('change'));
          }, noWeekends: false
        });

    // Init EndDateText.
    let $endDateText = $(this.$refs.endDateText);
    $endDateText.initFromDatePicker(
        {
          dateElId: $endDateText.attr('id'),
          linkDateElId: null,
          minDate: $endDateText.data('min-date-text'),
          maxDate: $endDateText.data('max-date-text'),
          bs3: true,
          f: function (selectedDate) {
            _component.$data.dateRule.endDateText = selectedDate;
            _component.$refs.endDateText.dispatchEvent(new Event('change'));
          }, noWeekends: false
        });
  }
}
</script>

<style scoped>

</style>